import React from "react";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import ViewDetails from "./components/ViewUsers";

export default function PaymentDetailsItems({ title, data }) {
  const { t } = useTranslation();
  return (
    <MuiPaper className="mt-4">
      <Grid container>
        <Grid item xs={12} className="m-3">
          <p className="normalTitle">{t(title)}</p>
        </Grid>
        <Grid item xs={12}>
          <ViewDetails data={data?.Detail} />
        </Grid>
        <Grid item xs={12} className="payment-details-show-items">
          <p>
            {`${t("totalAmounts")} : `}
            <strong className="mx-2">
              {data?.Detail?.PriceCalcList.toLocaleString()}
            </strong>
          </p>
          {data?.Detail?.DiscountCalcPrice !== 0 && (
            <p>
              {`${t("discount")} : `}
              <strong>
                {data?.Detail?.DiscountCalcPrice.toLocaleString()}
              </strong>
            </p>
          )}
          {data?.Detail?.PriceTax !== 0 && (
            <p>
              {`${t("totalTax")} : `}
              <strong>{data?.Detail?.PriceTax.toLocaleString()}</strong>
            </p>
          )}
          <p>
            {`${t("totalPayment")} : `}
            <strong className="mx-2">
              {data?.Detail?.PriceShow.toLocaleString()}{" "}
            </strong>
          </p>
        </Grid>
      </Grid>
    </MuiPaper>
  );
}
